import React, { useEffect, useState } from "react";

import { Outlet, useNavigate } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import { professionalDetailSchema } from "./ValidationSchema";
import {
  getEducation,
  getOccupation,
  getAllIncome,
  getCountry,
  getState,
  getCity,
  addProfessionalDetails,
} from "../asiosConfig";
import {
  Grid,
  Button,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";

import CommonPopup from "./CommonPopup";

const RegisterProfessionalStep = ({ onNext, registrationData }) => {
  const [educations, setEducations] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [incomes, setIncomes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const navigate = useNavigate();

  const [isSuccess, setIsSuccess] = useState(false);

  const [popup, setPopup] = useState({
    open: false,
    type: "", // "success" | "error"
    message: "",
  });

  const initialValues = {
    education: "",
    educationDetail: "",
    occupation: "",
    occupationDetail: "",
    income: "",
    country: "",
    state: "",
    city: "",
    user_id: registrationData?.user_id || localStorage.getItem("user"),
    token: registrationData?.token || localStorage.getItem("token"),
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [eduRes, occRes, incRes, counRes] = await Promise.all([
          getEducation(),
          getOccupation(),
          getAllIncome(),
          getCountry(),
        ]);
        setEducations(eduRes.data.data || []);
        setOccupations(occRes.data.data || []);
        setIncomes(incRes.data.data || []);
        setCountries(counRes.data.data || []);
      } catch (error) {
        // catch (error) {
        //     toast.error('Failed to fetch data');
        // }
        setPopup({
          open: true,
          type: "error",
          message: "Failed to fetch master data",
        });
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchState = async () => {
      if (initialValues.country) {
        try {
          const response = await getState(initialValues.country);
          setStates(response.data.data || []);
        } catch (error) {
          // catch (error) {
          //     toast.error('Failed to fetch states');
          // }
          setPopup({
            open: true,
            type: "error",
            message: "Failed to fetch states",
          });
        }
      }
    };
    fetchState();
  }, [initialValues.country]);

  useEffect(() => {
    const fetchCity = async () => {
      if (initialValues.state) {
        try {
          const response = await getCity(initialValues.state);
          setCities(response.data.data || []);
        } catch (error) {
          // catch (error) {
          //     toast.error('Failed to fetch cities');
          // }

          setPopup({
            open: true,
            type: "error",
            message: "Failed to fetch cities",
          });
        }
      }
    };
    fetchCity();
  }, [initialValues.state]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await addProfessionalDetails(values);

      if (response.status === 200 || response.status === 201) {
        setPopup({
          open: true,
          type: "success",
          message: "Professional details filled successfully",
        });
      } else {
        setPopup({
          open: true,
          type: "error",
          message: response.data.message || "Failed to save",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        message: error.response?.data?.message || "Error saving details",
      });
    } finally {
      setSubmitting(false);
    }
  };

  //     const handlePopupClose = () => {
  //   setPopup({ open: false, type: "", message: "" });

  //   if (popup.type === "success") {
  //     onNext(3); // go to Contact Details step
  //   }
  // };

  const handlePopupClose = () => {
    setPopup({ open: false, type: "", message: "" });

    if (popup.type === "success") {
      localStorage.setItem("register_current_step", 3);
      onNext(3);
    }
  };

  const InputBox = ({
    name,
    value,
    onChange,
    placeholder,
    select,
    children,
    type = "text",
  }) => (
    <div
      style={{
        borderRadius: "10px",
        backgroundColor: "#f5fcfe",
        border: "1px solid #d4d4d4",
        height: "48px",
        display: "flex",
        alignItems: "center",
        padding: "0 15px",
        fontFamily: "Montserrat",
      }}
    >
      {select ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          variant="standard"
          disableUnderline
          fullWidth
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: "#f5fcfe",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              },
            },
          }}
          sx={{
            fontSize: "15px",
            color: "#333",
            fontFamily: "Montserrat, sans-serif",
            "& .MuiSelect-select": {
              padding: "0 !important",
              fontFamily: "Montserrat",
            },
          }}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {children}
        </Select>
      ) : (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "15px",
            fontWeight: 500,
            color: "#333",
          }}
        />
      )}
    </div>
  );

  return (
    <div
      style={{
        flex: "1 1 500px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={professionalDetailSchema}
        onSubmit={handleSubmit}
      >
        {({
          isSubmitting,
          values,
          handleChange,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form
            style={{
              width: "100%",
              maxWidth: "520px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              textAlign: "left",
              fontFamily: "Montserrat",
            }}
          >
            {/* <InputBox
                            name="education"
                            value={values.education}
                            onChange={handleChange}
                            placeholder="Education"
                            select
                        >
                            {educations.map((edu) => (
                                <MenuItem key={edu.id} value={edu.id} sx={{ fontFamily: "Montserrat", fontSize: "16px", color: "#171616ff" }}>
                                    {edu.education}
                                </MenuItem>
                            ))}
                        </InputBox>
                        <ErrorMessage name="education" component="div" style={{ color: 'red', fontSize: '12px', marginBottom: '2px' }} />

                        <InputBox
                            name="educationDetail"
                            value={values.educationDetail}
                            onChange={handleChange}
                            placeholder="Education Details"
                        />
                        <ErrorMessage name="educationDetail" component="div" style={{ color: 'red', fontSize: '12px', marginBottom: '2px' }} /> */}

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <InputBox
                  name="education"
                  value={values.education}
                  onChange={handleChange}
                  placeholder="Education"
                  select
                >
                  {educations.map((edu) => (
                    <MenuItem key={edu.id} value={edu.id}>
                      {edu.education}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="education"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <InputBox
                  name="educationDetail"
                  value={values.educationDetail}
                  onChange={handleChange}
                  placeholder="Education Details"
                />
                <ErrorMessage
                  name="educationDetail"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
            </Grid>

            <InputBox
              name="occupation"
              value={values.occupation}
              onChange={handleChange}
              placeholder="Profession"
              select
            >
              {occupations.map((occ) => (
                <MenuItem
                  key={occ.id}
                  value={occ.id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {occ.occupation}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="occupation"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="occupationDetail"
              value={values.occupationDetail}
              onChange={handleChange}
              placeholder="Professional Details"
            />
            <ErrorMessage
              name="occupationDetail"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="income"
              value={values.income}
              onChange={handleChange}
              placeholder="Annual Income"
              select
            >
              {incomes.map((inc) => (
                <MenuItem
                  key={inc.tbl_income_id}
                  value={inc.tbl_income_id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {inc.income_type}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="income"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="country"
              value={values.country}
              // onChange={(e) => {
              //     handleChange(e);
              //     const selectedCountry = e.target.value;
              //     setFieldValue('state', '');
              //     setFieldValue('city', '');
              //     if (selectedCountry) {
              //         getState(selectedCountry).then((response) => {
              //             setStates(response.data.data || []);
              //         }).catch(() => {
              //             setStates([]);
              //         });
              //     } else {
              //         setStates([]);
              //         setCities([]);
              //     }
              // }}

              onChange={(e) => {
                const value = e.target.value;

                // ✅ update country + validate
                setFieldValue("country", value, true);
                setFieldTouched("country", true, false);

                // 🔁 reset dependent fields WITHOUT validation
                setFieldValue("state", "", false);
                setFieldTouched("state", false, false);

                setFieldValue("city", "", false);
                setFieldTouched("city", false, false);

                // fetch states
                if (value) {
                  getState(value)
                    .then((res) => setStates(res.data.data || []))
                    .catch(() => setStates([]));
                } else {
                  setStates([]);
                  setCities([]);
                }
              }}
              placeholder="Country"
              select
            >
              {countries.map((coun) => (
                <MenuItem
                  key={coun.id}
                  value={coun.id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {coun.country}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="country"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="state"
              value={values.state}
              // onChange={(e) => {
              //     handleChange(e);
              //     const selectedState = e.target.value;
              //     setFieldValue('city', '');
              //     if (selectedState) {
              //         getCity({ state_id: selectedState }).then((response) => {
              //             setCities(response.data.data || []);
              //         }).catch(() => {
              //             setCities([]);
              //         });
              //     } else {
              //         setCities([]);
              //     }
              // }}

              onChange={(e) => {
                const value = e.target.value;

                setFieldValue("state", value, true);
                setFieldTouched("state", true, false);

                // reset city
                setFieldValue("city", "", false);
                setFieldTouched("city", false, false);

                if (value) {
                  getCity({ state_id: value })
                    .then((res) => setCities(res.data.data || []))
                    .catch(() => setCities([]));
                } else {
                  setCities([]);
                }
              }}
              placeholder="State"
              select
            >
              {states.map((st) => (
                <MenuItem
                  key={st.id}
                  value={st.id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {st.state}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="state"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="city"
              value={values.city}
              // onChange={handleChange}
              onChange={(e) => {
                const value = e.target.value;

                setFieldValue("city", value, true);
                setFieldTouched("city", true, false);
              }}
              placeholder="City"
              select
            >
              {cities.map((ct) => (
                <MenuItem
                  key={ct.id}
                  value={ct.id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {ct.city}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="city"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              style={{
                borderRadius: "50px",
                background:
                  "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                height: "49px",
                textTransform: "none",
                fontFamily: "Montserrat",
                boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
                 gap: "10px",
              }}
            >
              {isSubmitting && (
                <CircularProgress
                  size={20}
                  thickness={5}
                  sx={{ color: "#fff" }}
                />
              )}

              {isSubmitting ? "Saving..." : "Next"}
            </Button>
          </Form>
        )}
      </Formik>
      {/* <Popup open={popupOpen} onClose={handlePopupClose} message={popupMessage} /> */}
      <CommonPopup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default RegisterProfessionalStep;
